import { UiService } from "./UiService";
import { getAppServices } from "./index";
import { DataActions, MessageAction } from "./actions";
import { CurrencyUtil } from "@eres/core";
import I8N from "@eres/core/dist/I8N";
import { formatAppDate } from "../utils/Utils";

export default class UiServiceBase implements UiService {
	hideLoading(): void {
		getAppServices().storeService.dispatch( { type: DataActions.ON_LOAD_DATA_DONE } );
	}

	showLoading(): void {
		getAppServices().storeService.dispatch( { type: DataActions.ON_LOAD_DATA } );
	}

	showMessage( message: string ): void {
		getAppServices().storeService.dispatch( { type: MessageAction.SHOW_MESSAGE, payload: message } );
	}

	showErrorMessage( message: string ): void {
		getAppServices().storeService.dispatch( { type: MessageAction.SHOW_ERROR, payload: message } );
	}

	toDisplayCurrency( value: number, withAed: boolean ): string {
		if ( value && value !== 0 ) {
			let v = CurrencyUtil.toFormattedCurrency( value );
			if ( withAed ) {
				v = appendAed( v );
			}
			return v;
		}
		return "-";
	}

	toDisplayDate( date: Date ): string {
		return formatAppDate( date );
	}

	toDisplayShortCurrency( value: number, withAed: boolean ): string {
		if ( value && value !== 0 ) {
			let v = CurrencyUtil.toSimpleCurrency( value );
			if ( withAed ) {
				v = appendAed( v );
			}
			return v;
		}
		return "-";
	}

}

function appendAed( value: string ) {
	const Strings = getAppServices().assetService.Strings();
	if ( I8N.isRTL() ) {
		value = "\u200e\u200f" + Strings.aed + " \u200e" + value;
	} else {
		value = value + " " + Strings.aed;
	}
	return value;
}
